<template>
  <v-container fluid style="width: 100%; padding: 0" class="fontscolor">
    <Header />
    <article class="text-center1 mobile-center1 v-full-height splash">
      <section class="fw-section">
        <div class="container fullwidthsec">
          <div class="row" style="padding-top: 50px">
            <div class="col-sm-3"></div>

            <div class="col-sm-6">
              <div class="page-title title-size-normal white1">
                <div class="container">
                  <div class="inner">
                    <div class="column">
                      <center>
                        <div class="titlelogin">Reset password</div>
                      </center>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="row padding-bottom-1x">
                  <div class="col-xs-0 text-left"></div>
                </div>
                <label
                  for="password"
                  class="control-label"
                  style="color: #ffffff"
                  >New Password</label
                >
                <input
                  type="password"
                  v-model="password"
                  name="password"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && !password }"
                />
                <div v-show="submitted && !password" class="invalid-feedback">
                  Password is required
                </div>
              </div>

              <div class="form-group">
                <div class="row padding-bottom-1x">
                  <div class="col-xs-0 text-left"></div>
                </div>
                <label
                  for="password"
                  class="control-label"
                  style="color: #ffffff"
                  >Confirm new Password</label
                >
                <input
                  type="password"
                  v-model="password2"
                  name="password2"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && !password }"
                />
                <div v-show="submitted && !password" class="invalid-feedback">
                  Password is required
                </div>
              </div>

              <div class="form-group">
                <p class="subtitle error-msg">{{ errorMsg }}</p>
                <button
                  class="btn btn-ghost btn-rounded btnl1 btn-block waves-effect waves-light"
                  type="submit"
                  @click="resetPassword()"
                >
                  Reset Password
                </button>
              </div>
            </div>
          </div>
          <div class="col-sm-3"></div>
        </div>
        <div class="padding-bottom-2x"></div>
        <center>
          <router-link to="/login"> Go back to Login</router-link>
        </center>
      </section>

      <v-dialog
        v-model="dialog"
        max-width="600px"
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar color="primary" dark>Forgot Password</v-toolbar>
          <v-card-text class="text-h5">
            <v-container fluid="true"> </v-container>
            Thanks! If there's an account associated with this email, we'll send
            the password reset instructions immediately.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="dialog = false"
              class="text-h6"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <dialogConfirm ref="confirm"></dialogConfirm>
    </article>
    <Footer />
    <vue-cookies-consent
      backgroundButton="#1972f5"
      borderRadius="5"
      backgroundButtonHover="#3A4F52"
      offsetY="5"
      style="z-index: 1000"
    >
      <template #description>
        <p>
          We use cookies to ensure you get the best experience on our website
          <router-link to="privacy-policy"
            ><span style="color: #0a64eb">Read more</span></router-link
          >
        </p>
      </template>
      <template #button>Accept cookies</template>
    </vue-cookies-consent>
  </v-container>
</template>

<script>
import Header from "./Header.vue";
import Footer from "./Footer.vue";
import VueCookiesConsent from "@norvikit/vue-cookies-consent";
export default {
  components: {
    Header,
    Footer,
    VueCookiesConsent,
  },

  data() {
    return {
      email: "",
      password: "",
      password2: "",
      dialog: false,
    };
  },
  computed: {},
  methods: {
    showInfo(message) {
      if (
        this.$refs.confirm.openInfo("Error", message, {
          color: "blue",
        })
      );
    },
    async showInfoSuccess() {
      if (
        await this.$refs.confirm.openInfo(
          "Success",
          "Password has been changed successfully",
          {
            color: "blue",
          }
        )
      ) {
        // yes

        setTimeout(() => {
          this.$router.push({
            name: "Login",
          });
        }, 800); // opóźnienie 0.8 sekundy
      }
    },
    resetPassword() {
      if (this.password == null || this.password.length == 0) {
        this.showInfo("The password can't be empty");
      }
      if (this.password != this.password2) {
        this.showInfo("The password and confirmation password do not match.");
      }
      if (
        this.$route.params.resetToken != null &&
        this.$route.params.resetToken.length > 3
      ) {
        this.$store
          .dispatch("resetPassword", {
            password: this.password,
            token: this.$route.params.resetToken,
          })
          .then((response) => {
            //this.processRoutes(response.routes);
            if (response.data.status == 0) {
              this.showInfoSuccess();
            } else {
              this.showInfo("Link is not valid or expired");
            }
          });

        /*this.$store
          .dispatch("resetPassword", {
            password: this.password,
            token: this.$route.params.resetToken,
          })
          .then(() => {});*/
      }
    },
  },
};
</script>



<style>
a {
  color: red;
}
.error-msg {
  color: red;
  font-weight: bold;
}
</style>

<style scoped>
.wlink a,
a:active,
a:hover {
  color: #ffffff !important;
}
.v-application a {
  color: #ffffff !important;
}

.btnl1 {
  color: #ffffff !important;
  background-color: #1972f5;
}

.btnl1:hover {
  background-color: #0a64eb;
}
.fullwidthsec {
  max-width: 1200px;
}
@media only screen and (max-width: 600px) {
  .fullwidthsec {
    max-width: 350px;
  }
}
</style>